import { Controller } from "@hotwired/stimulus"
import { markerIcon } from "./base_search_controller"

export default class extends Controller {
  static targets = [ "map", "address" ]

  async initialize() {
    await google.maps.importLibrary("maps");
    await google.maps.importLibrary("marker")
  }

  mapTargetConnected() {
    this.initMap()
    this.addMarkers()
  }

  initMap() {
    const options = {
      mapId: "3fe2568bfd28a7e1", // TODO: maybe use different id
      disableDefaultUI: true,
      zoomControl: true,
      mapTypeControl: false,
    }

    this.map = new google.maps.Map(this.mapTarget, options)
  }

  addMarkers() {
    if (this.addressTargets.length === 1) {
      const address = this.addressTargets[0];
      const position = {
        lat: parseFloat(address.dataset.lat),
        lng: parseFloat(address.dataset.lng)
      };

      this.addMarker(address);
      this.map.setCenter(position);
      this.map.setZoom(14);

    } else {
      this.bounds = new google.maps.LatLngBounds()

      this.addressTargets.forEach((address) => {
        this.addMarker(address);

        this.bounds.extend({
          lat: parseFloat(address.dataset.lat),
          lng: parseFloat(address.dataset.lng)
        })
      })

      this.map.fitBounds(this.bounds)
    }
  }

  addMarker(address) {
    new google.maps.marker.AdvancedMarkerElement({
      position: {
        lat: parseFloat(address.dataset.lat),
        lng: parseFloat(address.dataset.lng)
      },
      content: markerIcon(),
      map: this.map,
      title: address.dataset.title
    })
  }
}
